<template>
  <div ref="mountPoint"></div>
</template>

<script>
import Vue from "vue";
import { mapGetters } from "vuex";
export default {
  name: "MwFormView",
  props: {
    readOnly: {
      type: Boolean,
      default: false
    },
    taskId: {
      type: String,
      default: ""
    },
    appId: {
      type: String,
      default: ""
    },
    businessId: {
      type: String,
      default: ""
    },
    draftsDocId: {
      type: String,
      default: ""
    },
    extParams: {
      type: Object,
      default: () => ({})
    },
    flowKey: {
      type: String,
      default: ""
    },
    formKey: {
      type: String,
      default: ""
    },
    moduleId: {
      type: String,
      default: ""
    },
    formVersion: {
      type: String,
      default: ""
    },
    tempBusinessId: {
      type: String,
      default: ""
    },

    value: {
      type: Object,
      default: () => ({})
    },

    formOpenSource: {
      type: String,
      default: "PcWebsite"
    },
    dirty: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      taskData: {},
      activity: {},
      activityId: "",
      fieldMapping: {},
      formName: "",
      formId:"",
      processDefinitionId: "",
      processDefinitionName: "",
      formInst: null,

      extraFormField: {},
      authFields: undefined,
      type: "",

      commentFields: [],
      miniCommentFields: [],
      components: [],

      batchId: "",

      createTime: "",

      renderTimeout: null
    };
  },
  computed: {
    ...mapGetters(["expUser", "userInfo", "initInfo"])
  },
  mounted() {
    this.renderForm();
  },

  beforeDestroy() {
    this.teardown();
  },

  watch: {
    businessId() {
      clearTimeout(this.renderTimeout);
      this.renderTimeout = setTimeout(this.renderForm, 0);
    },
    appId() {
      clearTimeout(this.renderTimeout);
      this.renderTimeout = setTimeout(this.renderForm, 0);
    },
    moduleId() {
      clearTimeout(this.renderTimeout);
      this.renderTimeout = setTimeout(this.renderForm, 0);
    }
  },

  methods: {
    async renderForm() {
      if (this.moduleId) {
        this.beforeInstallFormView();
      }
    },
    async beforeInstallFormView() {
      const { result } = await this.mwApi.config.moduleConfig({
        dataId: this.businessId
          ? this.businessId
          : this.tempBusinessId
            ? `_${this.tempBusinessId}`
            : "",
        taskId: this.taskId,
        processDefinitionId: this.taskId ? this.processDefinitionId : "",
        activityId: this.taskId ? this.activityId : "",
        processDefinitionId: this.flowKey,
        flowFlag: false,
        forceModuleForm: false,
        moduleId: this.moduleId,
        appId: this.appId,
        draftsDocId: this.draftsDocId
      });
      this.$emit("update:appId", result.appId);
      this.$emit("update:formId", result.formId);
      this.$emit("update:formVersion", result.formVersion);
      this.$emit("update:formKey", result.formKey);
      this.formName = result.name;
      this.$emit("update:type", result.type);
      this.$emit("update:value", result.formData);
      this._originalFormData = result.formData;
      this.createTime = result.createTime;
      this.authFields = result.authFields;
      this.formId=result.formId;
      this.formKey=result.formKey;
      if (result.attr && result.attr.fieldMapping) {
        this.fieldMapping = result.attr.fieldMapping;
      }
      if (result.draftsDocId !== undefined) {
        this.$emit("update:businessId", result.draftsDocId);
      }
      if (result.tempDraftsDocId !== undefined) {
        this.$emit("update:tempBusinessId", result.tempDraftsDocId);
      }
      this.$nextTick(() => {
        this.installFormView(result.content);
      });
    },
    installFormView(dd) {
      let me=this;
      if (this.formInst) this.teardown();
      $WR.ready(manager => {
        this.$emit("getTitle", dd.name || dd.title);

        manager.create(
          {
            xtype: "Form",
            constantValues: this.getConstantValues(),
            resolvers: this.getResolvers(),
            $dd: {
              ...dd,
              hideHead: true,
              textMode: this.readOnly
            },
            $cc: this.authFields,
            user: this.expUser,
            values: this.getFormValues()
          },
          formInst => {
            this.formInst = formInst;
            formInst.on("afterRender", () => {
              if (this.businessId) {
                if (this.type === "module_flow") {
                  // this.handleCommentFields();
                }
              }
              this.handleFields();
            });
            var mark = (me.activity && me.activity.mark) ? me.activity.mark:"";
            var marks = mark ? mark.split(","):[];
            let rootCtx={
              "$userName":PF.userInfo.name,
              "$loginId":PF.userInfo.loginId,
              "$roleNames":PF.userInfo.roleNames,
              "$deptIdChain":PF.userInfo.deptIdChain,
              '$allIdentityRoleNames':PF.userInfo.allIdentityRoleNames,
              "$ext":{},
              '$flowMarks':marks
            };
            formInst.setExpressionContext(null,{},true);//不清楚为什么第一次设值设不进去，所以加第二次setExpressionContext yhq 2019/03/30
            formInst.setExpressionContext(null,rootCtx);
            me.$commentMinComponent = [];
            me.$newForm = formInst;
            formInst.on("manualChange", () => {
              this.$emit("update:dirty", true);
              this.$emit("dirty");
            });

            this.formInst.getExtForm = () => {
              return {
                formData: {
                  id: this.businessId,
                  ...this.formData()
                },
                action: "",
                taskId: this.taskId,
                appId: this.appId,
                businessId: this.businessId,
                formId:this.formId,
                taskdata: this.taskData,
                extParams: this.extParams,
                flowKey: this.flowKey,
                formVersion: this.formVersion,
                activity: this.activity,
                draftsDocId: this.draftsDocId,
                batchId: this.batchId,
                tempBusinessId: this.tempBusinessId,
                fieldMapping: this.fieldMapping,
                formName: this.formName,
                processDefinitionId: this.processDefinitionId,
                processDefinitionName: this.processDefinitionName,
                comment: [],
                startProcess: () => {},
                formActionComplete: () => {},
                refreshComment: this.refreshComment,
                setBtnLoading: () => {},
                btnDebounce: () => {},
                formOpenSource: this.formOpenSource
              };
            };
            this.formInst.__originalExtForm = this;
            this.$emit("beforeRender", formInst);
            formInst.render(this.$refs.mountPoint);
          }
        );
      });
    },
    getConstantValues() {
      return {
        taskId: this.taskId,
        appId: this.appId,
        businessId: this.businessId,
        draftsDocId: this.draftsDocId,
        taskData: this.taskData,
        extParams: this.extParams,
        flowKey: this.flowKey,
        moduleId: this.moduleId,
        formId: this.formId,
        formKey: this.formKey,
        formVersion: this.formVersion,
        activity: this.activity,
        tempBusinessId: this.tempBusinessId,
        fieldMapping: this.fieldMapping,
        formName: this.formName,
        processDefinitionId: this.processDefinitionId,
        processDefinitionName: this.processDefinitionName
      };
    },
    getResolvers() {
      return {
        fnDataResolver: this.fnDataResolver(),
        fnDataItemResolver:this.fnDataItemResolver(),
        fnImbeddedObjResolver: this.fnImbeddedObjResolver()
      };
    },

    getFormValues() {
      return this.value;
    },
    fnImbeddedObjResolver() {
      let me=this;
      return objId => {
        return new (function (formField) {
          var value = [];
          var component;
          var $data;
          var $obj;
          PF.apply(this, {
            init: function (d, obj) {
              $data = d;
              $obj = obj;
            },
            mount: function (fnMount) {
              var html;
              let config = Object.assign({
                expUser: me.expUser,
                getForm: function () {
                  if(!me.formInst.taskData)me.formInst.taskData = {};
                  if(!me.formInst.__originalExtForm._originalFormData){
                    me.formInst.__originalExtForm._originalFormData = me._originalFormData;
                  }
                  return me.formInst;
                },
                getCurrentObject: function () {
                  return $obj
                },
                $previewMode: false,
                getFormValue: function () {
                  return me.formData();
                },
                getConfig: function () {
                  return $data;
                },
                getData: function () {
                  return {
                    businessId: me.businessId,
                    tempBusinessId: me.tempBusinessId,
                    formKey: me.formKey,
                    formId: me.formId,
                    formVersion: me.formVersion
                  }
                },
                getFormObject: function () {
                  return me;
                }
              });

              switch (objId) {
                case 'attachment-list': {
                  component = new (Vue.component('form-attachment-list'))({params: me._data, config: config});
                  fnMount(component.$mount().$el);
                  break;
                }
                case 'attachment-list-min': {
                  component = new (Vue.component('form-attachment-list-min'))({params: me._data, config: config});
                  fnMount(component.$mount().$el);
                  break;
                }
                case 'document-editor': {
                  component = new (Vue.component('form-document-editor'))({params: me._data, config: config});
                  fnMount(component.$mount().$el);
                  break;
                }
                case 'zw-attachment-list': {
                  component = new (Vue.component('form-zw-attachment-list'))({params: me._data, config: config});
                  fnMount(component.$mount().$el);
                  break;
                }
                case 'comment-list': {
                  component = new (Vue.component('form-comment-list'))({params: me._data, config: config});
                  fnMount(component.$mount().$el);
                  break;
                }
                case 'comment-list-min': {
                  component = new (Vue.component('form-comment-list-min'))({params: me._data, config: config});
                  fnMount(component.$mount().$el);
                  break;
                }
                case 'imbedded-view': {
                  component = new (Vue.component('form-imbedded-view'))({params: me._data, config: config});
                  fnMount(component.$mount().$el);
                  break;
                }
                case 'rel-file-selection': {
                  component = new (Vue.component('form-rel-file-selection'))({params: me._data, config: config});
                  fnMount(component.$mount().$el);
                  break;
                }
                default: {
                  if ($data.pageType === "page") {
                    component = PF.createVue({
                      template: "<mw-inner-page :pageId='pageId' noWrap :params='params'></mw-inner-page>",
                      data: {
                        pageId: objId,
                        params: {data: me._data, config: config}
                      }
                    });
                    fnMount(component.$mount().$el);
                  } else if ($data.pageType === "pageData" && $obj.getPageData) {
                    let pageData = $obj.getPageData();
                    pageData.params = {data: me._data, config: config};
                    component = PF.createVue(pageData);
                    fnMount(component.$mount().$el);
                  }
                }
              }
              if (html) {
                fnMount($('<div>' + html + '</div>'));
              }
              return component;
            },
            onEvent: function (args) {
              if (component) {
                if (component.dealWithEvent) {
                  component.dealWithEvent(args);
                }
              } else {
                if (args.dd.viewId && args.data.id) {
                  me.mwApi.app.getApplicationItems([args.dd.viewId], "").then((res) => {
                    let mixId = res.result[0].content.table.moduleId;
                    if (mixId) {
                      let me = this;
                      let p = {};
                      p.businessId = args.data.id;
                      p.moduleId = mixId;
                      p.size = 'large_large'
                      p.type = 'normal'
                      p.editMode = me.editMode;
                      p.appId = '';
                      PF.show('normalForm', p, function () {
                      });
                    }
                  })
                  //viewId
                }
              }
            },
            setValue: function (value) {
              //console.log(value);
            },
            getValue: function () {
              //return value;
            },
            setReadOnly: function () {
            },
            destroy: function () {
              if (component)
                component.$destroy();
            },
            show: function (ops) {

              let config = Object.assign({
                expUser: me.expUser,
                getForm: function () {
                  return me.$newForm;
                },
                getCurrentObject: function () {
                  return $obj
                },
                $previewMode: false,
                getFormValue: function () {
                  return me.formData();
                }, getConfig: function () {
                  return $data;
                }, getData: function () {
                  return {
                    businessId: me.businessId,
                    tempBusinessId: me.tempBusinessId,
                    draftsDocId: me.draftsDocId,
                    formKey: me.formKey,
                    formId: me.formId,
                    formVersion: me.formVersion
                  }
                }, getFormObject: function () {
                  return me;
                }
              });

              switch (objId) {
                case 'department-selection': {

                  var multiple = $data.multiSelection == undefined ? false : $data.multiSelection;
                  PF.show('orgSelect', {multiple: multiple, config: config, value: ops.getValue()}, function (data) {
                    ops.setValue(data);
                  });
                  break;
                }
                case 'user-selection': {
                  var multiple = $data.multiSelection == undefined ? false : $data.multiSelection;
                  PF.show('orgSelect', {multiple: multiple, config: config, value: ops.getValue()}, function (data) {
                    ops.setValue(data);
                  });
                  break;
                }
                case 'department-user-selection': {

                  var multiple = $data.multiSelection == undefined ? false : $data.multiSelection;
                  PF.show('orgSelect', {multiple: multiple, config: config, value: ops.getValue()}, function (data) {
                    ops.setValue(data);
                  });
                  break;
                }
                case 'custom-selection': {
                  let multi = $data.multiSelection == undefined ? false : $data.multiSelection;
                  PF.show('viewSelect', {id: $data.viewId, config: config, multi: multi}, function (data) {
                    if (data) {
                      ops.setValue(data);
                    } else {
                      ops.setValue();
                    }
                  });
                  break;
                }
                default: {
                  if ($data.pageType == "page") {
                    config.setExtraFormField = function (d) {
                      me.extraFormField = d;
                    }
                    config.$obj = $obj;
                    config.ops = ops;
                    var params = {config: config, modelId: me.moduleId};
                    PF.dialog("mw-inner-page", {
                      title: $data.pageTitle, width: $data.pageWidth, height: $data.pageHeight,
                      propsData: {pageId: objId, params: params}
                    })
                  }
                }
              }

            },
            hide: function (ops) {
              ops.setValue(value);
            }
          });
        })(this);
      }
    },
    fnDataItemResolver() {
      let me=this;
      return async (dict, params, setDataItems) => {
        if ($.isFunction(params) && !setDataItems) {
          setDataItems = params;
          params = {};
        }
        me.mwApi.data.getDict(dict, params).then(function (data) {
          if (data.result && data.result.value) {
            let v = data.result.value.split(',');
            let v1 = [];
            let items = []
            v.forEach(function (d) {
              v1 = d.split('|');
              items.push({text: v1[1], value: v1[0]});
            });
            setDataItems(items);
          }
        });
      }
    },
    fnDataResolver() {
      let me=this;
      return async args => {
        if ('org-sel-default-value' === args.dataId) {
          me.mwApi.org.getCurrent(args.params).then(v => {
            args.fnSetData(v);
          })
        }

        if ('file-number-auto-generate' === args.dataId) {
          const {shouldGenerateFileNumber, getGenerateFileNumberParmas, beforeSetGeneratedFileNumber, setGeneratedFileNumber, updateRequestParams, afterGenerateFileNumber} = args;

          const formData = me.formData();

          if (shouldGenerateFileNumber(formData)) {
            const p = getGenerateFileNumberParmas(formData);
            me.mwApi.oasrv.generateAutoDocNumber(p).then(res => {
              if (res.success && res.result) {
                me.extraFormField = beforeSetGeneratedFileNumber(res.result);
                setGeneratedFileNumber(res.result);
                updateRequestParams(params => {
                  me.mwLodash.assign(params.$form, me.formData());
                });
              }
            }).then(afterGenerateFileNumber, afterGenerateFileNumber)
          } else {
            afterGenerateFileNumber();
          }
        }
      }
     },
    async handleCommentFields() {
      const cTaskNames = [];
      const cCategories = [];
      this.miniCommentFields.forEach(com => {
        const commentConfig = com.$options.config.getConfig();
        if (commentConfig.typeMark === "2") {
          cTaskNames.push(commentConfig.activityName);
        } else {
          cCategories.push(commentConfig.activityName);
        }
      });

      const category = cCategories.join(",");
      const taskName = cTaskNames.join(",");

      const { result } = await this.mwApi.business.queryCommentProcess({
        businessId: this.businessId,
        batchId: this.batchId,
        processDefinitionId: this.processDefinitionId,
        category,
        taskName
      });
      if (result) {
        this.miniCommentFields.forEach(com => {
          com.renderData(result);
        });
      }
    },

    refreshComment() {
      this.refreshcommentComponent();
    },

    refreshcommentComponent() {
      this.commentFields.forEach(com => {
        com.refreshComment();
      });
    },

    formData() {
      return {
        ...((this.formInst && this.formInst.getValue()) || {}),
        ...this.extraFormField
      };
    },
    recoverSelection() {
      const doc = document;

      const input = doc.createElement("input");
      input.setAttribute(
        "style",
        "width:0;height:0;outline:0;border:0;padding:0;margin:0;position:absolute;top:0;left:0;z-index:0"
      );
      doc.body.appendChild(input);
      input.click();
      input.focus();
      input.select();
      doc.body.removeChild(input);
    },

    teardown() {
      if (this.formInst) {
        try {
          this.formInst.destroy();
        } finally {
          this.recoverSelection();
        }
      }
    },

    handleFields() {
      const queue = [this.formInst];
      while (queue.length) {
        const item = queue.shift();

        if (item) {
          if (item.items) {
            for (let i = 0; i < item.items.length; i++) {
              queue.push(item.items.item(i));
            }
          }

          this.$emit('handleField', item);
        }
      }
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/common/components/extend/view/MwFormView.vue